module.exports = __webpack_public_path__ + "static/img/icon22.cd15bbc4.png";